module.exports = __webpack_public_path__ + "static/img/logo-yxtg.39d4e8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-yxtg.jpg
// module id = 6Zd7
// module chunks = 1